// extracted by mini-css-extract-plugin
module.exports = {"link-button":"_6bf55ce5dc--link-button--wyV6H"};